export default {
   apiBaseUrl:
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === '192.168.0.110'
         ? `http://${window.location.hostname}/cfc/api/`
         : 'http://petsatpeacesav-com.janus-thesabresolution-com.vps.ezhostingserver.com/cfc/api/',
};
